import { ComponentFactory, Label, LabelProps, Panel, PanelProps, Table, TableColumn } from "@mcleod/components";
import { ArrayUtil, ModelRow, ServerError } from "@mcleod/core";

export class DataConflictErrorPanel extends Panel {
    constructor(error: ServerError, props?: Partial<PanelProps>) {
        super(props);
        this.add(this.createErrorLabel())
        this.add(...this.createBulletedList());
        this.addAffectedFieldsTable(error);
    }

    private createErrorLabel() {
        return new Label({
            text: "Another user saved changes to this record while you were editing. Some of the fields you modified conflict with their updates. You can:",
            marginBottom: 15,
            fontBold: true
        });
    }

    private createBulletedList(): Label[] {
        const props: Partial<LabelProps> = {fontBold: true, padding:0}
        return ComponentFactory.createBulletedList([
            { text: "Refresh to discard your changes and load the latest version, or", ...props },
            { text: "Cancel and edit so you can resolve conflicts manually", ...props, marginTop: 4 }
        ]);
    }

    private addAffectedFieldsTable(error: ServerError) {
        let data = error.details;
        if (data != null && !Array.isArray(data) && data.conflicts != null)
            data = data.conflicts;

        if (ArrayUtil.isEmptyArray(data))
            return;

        this.add(new Label({ text: "Review Conflicting Fields:", fontBold: true, fontSize: "large", marginTop: 15}))

        const rows: ModelRow[] = [];
        let hasAuditData = false;
        for (const item of data) {
            if (item.user != null) {
                hasAuditData = true;
            }
            rows.push(new ModelRow("", false, item));
        }
        const tableFields = new Table({ headerVisible: false, maxHeight: 400, fillRow: true, marginTop: 15 })
        tableFields.addColumn(new TableColumn({ headingDef: { caption: "Field" }, cell: { field: "field" } }));
        tableFields.addColumn(new TableColumn({ headingDef: { caption: "Your Value" }, cell: { field: "attempted_value" } }));
        tableFields.addColumn(new TableColumn({ headingDef: { caption: "Their Value" }, cell: { field: "new_value" } }));
        if (hasAuditData) {
            tableFields.addColumn(new TableColumn({ headingDef: { caption: "User" }, cell: { field: "user" } }));
            tableFields.addColumn(new TableColumn({ headingDef: { caption: "Date" }, cell: { field: "date" } }));
        }
        tableFields.displayData(rows[0], rows, 0);
        this.add(tableFields);
    }
}
